import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  tone?: 'light' | 'dark';
  label?: string;
};
export function Countdown({
  tone = 'light',
  label = 'Esta oferta expira en'
}: CountdownProps) {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const units = [{
    value: '00',
    tag: 'HORAS'
  }, {
    value: String(minutes).padStart(2, '0'),
    tag: 'MIN'
  }, {
    value: String(seconds).padStart(2, '0'),
    tag: 'SEG'
  }];
  const isDark = tone === 'dark';
  return <div className="w-full" data-id="element-68" data-mp="10d4q5qk8scjq">
      <div className={`flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] sm:text-xs ${isDark ? 'text-ofm-100' : 'text-ofm-700'}`} data-id="element-69" data-mp="15bfzm06mkl1f">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="t2d5hc3824nw" />
        <span data-id="element-71" data-mp="t1tp3zt7zobz">{label}</span>
      </div>
      <div className="mt-2 flex items-center justify-center gap-2 sm:gap-3" data-id="element-72" data-mp="17qq3sfps7zlk">
        {units.map(unit => <div key={unit.tag} className="flex flex-col items-center" data-id="element-73" data-mp="12rd9j9wkzq8y">
            <div className={`flex h-14 w-14 items-center justify-center rounded-xl text-2xl font-extrabold tabular-nums shadow-sm sm:h-16 sm:w-16 sm:text-3xl ${isDark ? 'bg-white/12 text-white ring-1 ring-white/25' : 'bg-ofm-800 text-white'}`} data-id="element-74" data-mp="12u98n1k60kyz">
              {unit.value}
            </div>
            <span className={`mt-1 text-[10px] font-bold tracking-widest ${isDark ? 'text-ofm-200' : 'text-ofm-700/70'}`} data-id="element-75" data-mp="k3i207rkb8oa">
              {unit.tag}
            </span>
          </div>)}
      </div>
    </div>;
}